import { Cancel } from "@mui/icons-material";
import { Card, IconButton } from "@mui/material";
import React from "react";
import { GridUiListDeleteHandler } from "../functions/GridUiListDeleteHandler";
import { themeColors } from "Global/JsxThemeColor/JsxThemeColor";

const DeleteItemButton = ({ GridList, setGridList, index, onChange }) => {
  return (
    <React.Fragment>
      <IconButton
        sx={{ padding: "0", pb: ".5em" }}
        onClick={() =>
          GridUiListDeleteHandler(GridList, setGridList, index, onChange)
        }
      >
        <Cancel sx={{ fill: `${themeColors.ColorPrimary} !important` }} />
      </IconButton>
    </React.Fragment>
  );
};

export default DeleteItemButton;
